export const TOOLTIPS = {
  creativeHealth:
    'How healthy your creative portfolio is right now, from 0 to 100. Combines creative quality, how much of your budget is working, and how much is exposed to fatigue. Compared to the previous period.',
  creativeQuality:
    'The average quality score of your live creatives, weighted by spend, so your biggest investments count most.',
  budgetEfficiency:
    'The share of your spend going to creatives performing with no issues detected.',
  fatigueExposure:
    'The share of your spend running on creatives showing fatigue: falling CTR while CPM rises.',
  whereIsTheMoney:
    'Every dollar you spent in this period, split by creative health: working, at risk, or wasted.',
  working:
    'Spend on creatives performing at or above your benchmark, plus new creatives still in learning.',
  atRisk:
    'Spend on creatives showing early warning signs: fatigue, slipping performance, or rising costs. Act now to avoid waste.',
  wasted:
    'Spend on creatives well below your account benchmark, after passing the minimum spend to be judged fairly.',
  totalSpend:
    'Your total media spend for the selected brands, platforms and dates, compared to the previous period.',
  winnersRate:
    'Percentage of creatives that achieved top performance by your primary KPI, compared to the previous period.',
  recoverableBudget:
    "Your wasted spend's daily run rate projected over the next 30 days. What you could recover by acting on wasted creatives now.",
  losersRate:
    'Percentage of creatives that achieved the worst performance by your primary KPI, compared to the previous period.',
  creativesToWatch:
    'Creatives flagged from your live portfolio: winners to scale, fatigue to refresh, underperformers to cut. Open the workflow to act.',
  watchTopPerformer:
    'Beating your account benchmark on the primary KPI, after passing the minimum spend to be judged fairly. Keep it running.',
  watchFatigue:
    'Showing fatigue: falling CTR while CPM rises. Refresh or rotate the creative before its spend turns into waste.',
  watchUnderperformer:
    'Well below your account benchmark on the primary KPI, after passing the minimum spend to be judged fairly. Run Iteration Recommendations to fix it.',
  watchScalingCandidate:
    'Beating the benchmark on under 2% of your spend. A winner with room to grow: shift budget to it.',
};
